import {css} from 'lit'; export default css`:host{display:inherit;grid-template-columns:inherit;grid-gap:inherit;width:inherit;grid-column:inherit}`;
    